module.exports = __webpack_public_path__ + "img/1.06d1dd76.jpg";